document.addEventListener("DOMContentLoaded", function () {
    // #splide-voice の存在をチェック(存在する場合のみ初期化)
    if ($("#splide-voice").length > 0) {

        function voice() {
            new Splide("#splide-voice", {
                autoplay: true,
                type: "loop",
                arrows: true,
                pagination: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                interval: 5000,
                speed: 1000,
                perPage: 3,
                focus: 'center',
                gap: 32,
                perMove: 1,
                breakpoints: {
                    768: {
                        perPage: 1,
                        gap: 16,
                        padding: "8%",
                    },
                },
            }).mount();
        }
        voice();
    }
});